import { useDeleteAtmModel } from "./api/deleteAtmModel";
import { Button } from "reactstrap";


const DeleteAtmModel = ({handleCloseModal, atmModelId}: DeleteAtmModelProps)  => {
  
  const deleteAtmModelMutation = useDeleteAtmModel({ atmModelId});
  const handleSubmit = async (): Promise<void> => {
    deleteAtmModelMutation.mutateAsync({ 
      atmModelId: atmModelId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Μοντέλο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteAtmModelProps{
  atmModelId: number;
  handleCloseModal: () => void;
}

export default DeleteAtmModel;